const LIMIT = 3200
const BASE_WIDTH = 1440
const BASE_FONT_SIZE = 16

;(function () {
  function setRootFontSize() {
    if (typeof document === 'undefined') return

    const rootHtml = document.documentElement
    let rootWidth = rootHtml.clientWidth

    rootWidth = Math.min(LIMIT, rootWidth)

    const rem = rootWidth / (BASE_WIDTH / BASE_FONT_SIZE)
    rootHtml.style.fontSize = `${rem}px`
  }

  // 初始化 + 防抖处理
  if (typeof document !== 'undefined') {
    setRootFontSize()
    const debouncedResize = debounce(setRootFontSize, 300)
    window.addEventListener('resize', debouncedResize)
  }

  function debounce(fn, delay) {
    let timer
    return () => {
      clearTimeout(timer)
      timer = setTimeout(fn, delay)
    }
  }
})()
